<div>
    <!-- Buttons -->
    <!-- <div class="button-container mr-8">
        <button mat-raised-button color="primary" printSectionId="print-section" ngxPrint [useExistingCss]="true"
            class="custom-btn print-btn noPrint">
            Print
        </button>

        <button mat-dialog-close onclick="closeexp()" class="custom-btn close-btn noPrint">
            Close
        </button>
    </div> -->
    <div class="button-container mr-8">
        <button mat-raised-button color="primary" printSectionId="print-section" ngxPrint [useExistingCss]="true"
            class="custom-btn print-btn noPrint">
            Print
        </button>

        <button type="button" mat-raised-button matTooltip="Download Excel sheet" class="btn btn-danger"
            (click)="exportExcel('expense-report')" style="margin-right: 10px;">
            Export
        </button>

        <button mat-dialog-close onclick="closeexp()" class="custom-btn close-btn noPrint">
            Close
        </button>
    </div>

    <div class="loading-container" *ngIf="isLoading">
        <div class="ledger-spinner">
            <div class="ledger-spinner-ring"></div>
            <i class="ni ni-chart-bar-32"></i>
        </div>
        <p class="loading-text">Loading report&hellip;</p>
    </div>

    <div class="container" id="print-section" *ngIf="!isLoading">
        <div class="wrapper">
            <div class="row rowborder ml-2 mr-2">
                <div class="common">
                    <span>दिनांक : {{ getFormattedDate() }}</span>
                    <span>पृष्ठ क्र : 1</span>
                </div>
                <div class="common text-center" style="margin: 10px auto !important;">
                    <span>हिंदुस्थान प्रकाशन संस्था</span>
                    <span>विवेक साप्ताहिक</span>
                    <span>खर्च खाते अनूपुस्तिका</span>
                    <span style="font-size: 18px; color: red; background-color: yellow; margin-top: 5px;">
                        {{ expName }}<span *ngIf="subExpName"> - {{ subExpName }}</span>
                    </span>
                </div>
                <div class="common">
                    <span>दिनांक पासून : {{ startDate | date: 'dd-MM-yyyy' }}</span>
                    <span>दिनांक पर्यंत : {{ endDate | date: 'dd-MM-yyyy' }}</span>
                </div>
            </div>
            <div class="row rowborder ml-2 mr-2">
                <div class="col-2 common">
                    <span>सांकेतांक</span>
                    <span>दिनांक</span>
                </div>
                <div class="col-4">
                    <span style="font-size: 14px;font-weight: bold">तपशील</span>
                </div>
                <div class="col-2 text-end">
                    <span style="font-size: 14px;font-weight: bold; padding-right: 20px;">डेबिट</span>
                </div>
                <div class="col-2 text-end">
                    <span style="font-size: 14px;font-weight: bold; padding-right: 20px;">क्रेडिट</span>
                </div>
                <div class="col-2 text-end">
                    <span style="font-size: 14px;font-weight: bold; padding-right: 20px;">रक्कम</span>
                </div>
            </div>
            <div class="row rowborder ml-2 mr-2">

                <div class="col-2">

                </div>
                <div class="col-2">
                </div>
                <div class="col-2 text-end">
                    <span><strong>मागील बाकी :</strong></span>
                </div>
                <div class="col-2">
                    <span class="text-end" style="font-weight: bold;" *ngIf="openingBalType === 'DR'">{{
                        openingBalance.toFixed(2)
                        }}</span>
                </div>

                <div class="col-2">
                    <span class="text-end" style="font-weight: bold;" *ngIf="openingBalType === 'CR'">{{
                        openingBalance.toFixed(2)
                        }}</span>
                </div>
                <div class="col-2">
                    <!-- <span>{{cr_opening_bal | number:'1.2-2'}}</span> -->
                </div>
            </div>
            <div class="row ml-2 mr-2">
                <ng-container *ngFor="let item of vouchers">
                    <div class="col-2 common">
                        <span>{{ item['voucher_no'] }}</span>
                        <span>{{ item['voucher_date'] | date:'dd-MM-yyyy' }}</span>
                    </div>
                    <div class="col-4">
                        <span style="font-size: 13px;font-weight: bold;">
                            {{ subExpName || expName }}
                        </span>
                        <span *ngIf="item['rep_name']" style="font-size: 12px;">
                            (rep_name: {{ item['rep_name'] }})
                        </span>
                        <span *ngIf="item['narration']" style="font-size: 12px;">
                            (narration: {{ item['narration'] }})
                        </span>
                        <span *ngIf="item['pan_card']" style="font-size: 12px;">
                            (pan no: {{ item['pan_card'] }})
                        </span>
                        <span *ngIf="item['names']" style="font-size: 12px;">
                            ({{ item['names'] }})
                        </span>
                    </div>
                    <div class="col-2 text-end">
                        <span *ngIf="item.voucher_type == 'DR'">
                            {{ item['exp_amt'] }}
                        </span>
                    </div>
                    <div class="col-2 text-end">
                        <span *ngIf="item.voucher_type == 'CR'">
                            {{ item['exp_amt'] }}
                        </span>
                    </div>
                    <div class="col-2 text-end">
                        {{ item['total']}}
                    </div>
                </ng-container>
            </div>
            <div class="row rowborder rowbordertop ml-2 mr-2">
                <div class="col-2"></div>
                <div class="col-2"></div>
                <div class="col-2 common text-end">
                    <span style="margin-bottom: 5px;">एकूण :-</span>
                </div>

                <div class="col-2 common text-end">

                    <span>
                        {{ drTotal }}
                    </span>

                </div>

                <div class="col-2 common text-end">
                    <span>
                        {{ crTotal }}
                    </span>
                </div>
                <div class="col-2"></div>
            </div>
            <div class="row ml-2 mr-2">
                <div class="col-2"></div>
                <div class="col-2"></div>
                <div class="col-2 common text-end">
                    <span>बाकी पुढे :-</span>
                </div>

                <!-- DR Column -->
                <div class="col-2 common text-end">
                    <span *ngIf="finalTotal?.endsWith('Dr')">{{ finalTotal }}</span>
                </div>

                <!-- CR Column -->
                <div class="col-2 common text-end">
                    <span *ngIf="finalTotal?.endsWith('Cr')">{{ finalTotal }}</span>
                </div>

                <div class="col-2"></div>
            </div>
            <div class="row rowborder mb-4 ml-2 mr-2"></div>
        </div>
        <print-preview-layout-settings class="settings-section"></print-preview-layout-settings>

    </div>
</div>